// Auto-extracted from SellerAnalytics.jsx
import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Icon } from "../../components/Icon";
import { fmtK, fmtKShort } from "../../lib/money";
import { resolveImage } from "../../lib/images";
import { STATUS_TONES } from "./constants";

export function KpiBox({ label, value, growth, note }) {
  const growthNum = typeof growth === "number" ? growth : null;
  const up = growthNum != null && growthNum > 0;
  const down = growthNum != null && growthNum < 0;
  return (
    <Card pad={18}>
      <div
        style={{
          fontSize: 10.5,
          fontWeight: 800,
          color: C.muted,
          textTransform: "uppercase",
          letterSpacing: 1,
        }}
      >
        {label}
      </div>
      <div style={{ fontSize: 24, fontWeight: 900, color: C.charcoal, letterSpacing: "-0.6px", marginTop: 4 }}>
        {value}
      </div>
      {growthNum != null && (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            marginTop: 8,
            fontSize: 11,
            fontWeight: 800,
            color: up ? C.greenDk : down ? C.red : C.muted,
            background: up ? C.greenBg : down ? C.redBg : C.cream,
            padding: "3px 7px",
            borderRadius: 6,
          }}
        >
          <Icon name={up ? "trending-up" : down ? "trending-down" : "minus"} size={11} color={up ? C.greenDk : down ? C.red : C.muted} />
          {up ? "+" : ""}
          {growthNum.toFixed(1)}%
        </div>
      )}
      {note && (
        <div style={{ fontSize: 10.5, color: C.muted, marginTop: 6 }}>{note}</div>
      )}
    </Card>
  );
}
